import { render, staticRenderFns } from "./SwitchComponent.vue?vue&type=template&id=10f37b2c"
import script from "./SwitchComponent.vue?vue&type=script&lang=js"
export * from "./SwitchComponent.vue?vue&type=script&lang=js"
import style0 from "./SwitchComponent.vue?vue&type=style&index=0&id=10f37b2c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports